const TimelineMid = (props) => {

  const timeline_reached_class = () => {
    if(props.timeline_reached) {
      return("reached timeline-event");
    } else{
      return("timeline-event");
    }
  }


  return(
    <div className="timeline-item timeline-mid">
      <div className="timeline-item-flexcol">
        <span className="timeline-event-date-new">{props.date_time}</span>
        <span className="timeline-event-date-old">April 15th 2022</span>
        <div className={timeline_reached_class()}></div>
        <span className="timeline-event-name">{props.event_name}</span>
        <span className="timeline-event-date-spacer">M</span>
      </div>
    </div>
  )
}

export default TimelineMid;